import { FunctionComponent, ReactNode } from 'react';
import styles from './FeedingMomentContainer.module.scss';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';

export interface FeedingMomentContainerProps {
    selected: boolean;
    onSelectChange: (selected: boolean) => void;
    title: string;
    description: string;
    children?: ReactNode;
}

const FeedingMomentContainer: FunctionComponent<FeedingMomentContainerProps> = props => {
    const handleHeaderClick = () => {
        props.onSelectChange(!props.selected);
    };

    return (
        <div className={clsx(styles.container, props.selected && styles.containerSelected)}>
            <button
                type="button"
                className={styles.header}
                onClick={handleHeaderClick}
                aria-expanded={props.selected}
                aria-pressed={props.selected}
            >
                <div className={styles.headerText}>
                    <span className={styles.title}>{props.title}</span>
                    <span className={styles.description}>{props.description}</span>
                </div>
                <span
                    className={styles.checkWrapper}
                    aria-hidden
                >
                    <FontAwesomeIcon
                        icon={props.selected ? faCheckCircle : faCircle}
                        className={clsx(styles.checkIcon, props.selected && styles.checkIconSelected)}
                    />
                </span>
            </button>
            {props.selected && props.children != null && <div className={styles.content}>{props.children}</div>}
        </div>
    );
};

export default FeedingMomentContainer;
